import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';

const Music = lazy(() => import('./components/Music'));
const Events = lazy(() => import('./components/Events'));
const About = lazy(() => import('./components/About'));
const Contact = lazy(() => import('./components/Contact'));
const AdminApp = lazy(() => import('./admin/AdminApp'));

const reveal = {
  hidden: { opacity: 0, y: 44 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

const SectionReveal = ({ children }) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.06 }}
    variants={reveal}
  >
    {children}
  </motion.div>
);

const SectionPlaceholder = ({ id, className, minHeight = 320 }) => (
  <section id={id} className={className} aria-hidden="true" style={{ minHeight }} />
);

function MainSite() {
  return (
    <div className="app">
      <Navbar />
      <Hero />
      <Suspense fallback={<SectionPlaceholder id="music" className="music" minHeight={460} />}>
        <SectionReveal><Music /></SectionReveal>
      </Suspense>
      <Suspense fallback={<SectionPlaceholder id="events" className="events" minHeight={420} />}>
        <SectionReveal><Events /></SectionReveal>
      </Suspense>
      <Suspense fallback={<SectionPlaceholder id="about" className="about" minHeight={540} />}>
        <SectionReveal><About /></SectionReveal>
      </Suspense>
      <Suspense fallback={<SectionPlaceholder id="contact" className="contact" minHeight={640} />}>
        <SectionReveal><Contact /></SectionReveal>
      </Suspense>
    </div>
  );
}

function App() {
  return (
    <Suspense fallback={<div className="app" />}>
      <Routes>
        <Route path="/v1/controlls/admin/pixie/*" element={<AdminApp />} />
        <Route path="/*" element={<MainSite />} />
      </Routes>
    </Suspense>
  );
}

export default App;
